import { inject } from '@angular/core';
import { CanMatchFn, DefaultUrlSerializer, Router } from '@angular/router';

/**
 *
 * @param urlPath
 * @returns
 */
export const getAccountHeaderGuard = (urlPath: string) => {
  const profilingGuard: CanMatchFn = (): boolean => {
    const router = inject(Router); // Inject the Router service

    // Get the target URL from the current navigation
    const currentNavigation = router.getCurrentNavigation();
    if (!currentNavigation?.extractedUrl) {
      return false;
    }

    const urlSerializer = new DefaultUrlSerializer();
    const serializeUrl = urlSerializer.serialize(
      currentNavigation.extractedUrl
    );

    // Check if the target URL starts with the specified path
    const startsWithPath = serializeUrl.startsWith(urlPath);
    return startsWithPath;
  };

  return profilingGuard;
};
